
        import * as module0 from './controllers/final_controller.js';import * as module1 from './controllers/submit_controller.js'
        const modules = {
            "./controllers/final_controller.js": module0,
            "./controllers/submit_controller.js": module1,
        };
        export default modules;
      